/* Raizelle – "Arma tu pedido": varias prendas (colores, tallas, modelos) en un solo formulario contraentrega */
(function () {
  'use strict';
  if (window.__rzPedidoLoaded) return;
  window.__rzPedidoLoaded = true;

  var state = { cart: null, lastAdded: null, bypass: false };
  var LS_KEY = 'rz_pedido_last';
  try { var saved = JSON.parse(sessionStorage.getItem(LS_KEY) || 'null'); if (saved) state.lastAdded = saved; } catch (e) {}
  function saveLast() { try { sessionStorage.setItem(LS_KEY, JSON.stringify(state.lastAdded)); } catch (e) {} }

  function roots() { return Array.prototype.slice.call(document.querySelectorAll('[data-rz-pedido]')); }
  function productForm(root) {
    var sec = root.closest('.shopify-section') || document;
    return sec.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  }
  function currentId(root) {
    var f = productForm(root); var i = f && f.querySelector('input[name="id"]');
    return i && i.value ? String(i.value) : null;
  }
  function currentQty(root) {
    var f = productForm(root); var q = f && f.querySelector('input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1; return n > 0 ? n : 1;
  }
  function variantTitles(root) {
    if (root.__titles) return root.__titles;
    try { root.__titles = JSON.parse(root.querySelector('[data-rz-variants]').textContent); } catch (e) { root.__titles = {}; }
    return root.__titles;
  }
  function money(cents, cur) {
    try { return new Intl.NumberFormat('es-PE', { style: 'currency', currency: cur || 'PEN' }).format(cents / 100); }
    catch (e) { return 'S/ ' + (cents / 100).toFixed(2); }
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function json(url, body) {
    return fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) } : { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }
  function announce(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'rz-pedido', data: { source: 'rz-pedido', itemCount: cart.item_count } } }));
    } catch (e) {}
    document.querySelectorAll('cart-icon .cart-bubble__text-count, .cart-bubble__text-count').forEach(function (el) { el.textContent = cart.item_count; });
  }

  function render() {
    var cart = state.cart; if (!cart) return;
    roots().forEach(function (root) {
      var box = root.querySelector('[data-rz-box]');
      var list = root.querySelector('[data-rz-list]');
      if (!cart.item_count) { box.hidden = true; return; }
      box.hidden = false;
      root.querySelector('[data-rz-count]').textContent = cart.item_count + (cart.item_count === 1 ? ' prenda' : ' prendas');
      root.querySelector('[data-rz-total]').textContent = money(cart.total_price, cart.currency);
      list.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
        return '<li class="rz-pedido__item" data-key="' + esc(it.key) + '">' +
          (img ? '<img class="rz-pedido__img" src="' + esc(img) + '" alt="" loading="lazy" width="52" height="64">' : '<span class="rz-pedido__img"></span>') +
          '<div class="rz-pedido__info"><div class="rz-pedido__name">' + esc(it.product_title) + '</div>' +
          (it.variant_title ? '<div class="rz-pedido__var">' + esc(it.variant_title) + '</div>' : '') +
          '<div class="rz-pedido__price">' + money(it.final_line_price, cart.currency) + '</div></div>' +
          '<div class="rz-pedido__qty">' +
            '<button type="button" data-rz-q="-1" aria-label="Quitar una">' + (it.quantity > 1 ? '&minus;' : '&times;') + '</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-rz-q="1" aria-label="Agregar una">+</button>' +
          '</div></li>';
      }).join('');
    });
    paintIncluye();
  }

  function paintIncluye() {
    var cart = state.cart;
    roots().forEach(function (root) {
      var el = root.querySelector('[data-rz-incluye]'); if (!el) return;
      if (!cart || !cart.item_count) { el.textContent = ''; return; }
      var id = currentId(root);
      var same = state.lastAdded && id && String(state.lastAdded.id) === id && cart.items.some(function (i) { return String(i.variant_id) === id; });
      var t = same ? el.getAttribute('data-txt-solo') : el.getAttribute('data-txt-mas');
      var titles = variantTitles(root);
      var n = cart.item_count + (cart.item_count === 1 ? ' prenda' : ' prendas');
      el.textContent = (t || '').replace('[n]', n).replace('[v]', titles[id] || '');
    });
  }

  function refresh() { return json('/cart.js').then(function (c) { state.cart = c; render(); return c; }).catch(function () {}); }

  function toast(root, msg) {
    var t = root.querySelector('[data-rz-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(t.__h); t.__h = setTimeout(function () { t.hidden = true; }, 5000);
  }

  function add(root, btn) {
    var id = currentId(root); if (!id) return;
    var qty = currentQty(root);
    btn.setAttribute('aria-busy', 'true');
    json('/cart/add.js', { items: [{ id: parseInt(id, 10), quantity: qty }] })
      .then(function () {
        state.lastAdded = { id: id, qty: qty }; saveLast();
        return refresh();
      })
      .then(function (cart) {
        btn.removeAttribute('aria-busy');
        if (cart) announce(cart);
        var titles = variantTitles(root);
        toast(root, '✓ Agregado: ' + (titles[id] || 'tu prenda') + '. Elige otro color o talla, o toca «Pagar Contra Entrega».');
        var box = root.querySelector('[data-rz-box]');
        if (box && box.scrollIntoView && window.innerWidth < 750) box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        toast(root, (err && (err.description || err.message)) || 'No se pudo agregar. Inténtalo otra vez.');
      });
  }

  function changeLine(key, qty) {
    return json('/cart/change.js', { id: key, quantity: qty }).then(function (c) { state.cart = c; render(); announce(c); return c; });
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest && e.target.closest('[data-rz-add]');
    if (addBtn) { e.preventDefault(); add(addBtn.closest('[data-rz-pedido]'), addBtn); return; }
    var qb = e.target.closest && e.target.closest('[data-rz-q]');
    if (qb) {
      e.preventDefault();
      var li = qb.closest('[data-key]'); if (!li || !state.cart) return;
      var key = li.getAttribute('data-key');
      var item = state.cart.items.filter(function (i) { return i.key === key; })[0]; if (!item) return;
      var nq = item.quantity + parseInt(qb.getAttribute('data-rz-q'), 10);
      if (nq <= 0 && state.lastAdded && String(item.variant_id) === String(state.lastAdded.id)) { state.lastAdded = null; saveLast(); }
      changeLine(key, Math.max(0, nq));
    }
  });

  /* Botón de Releasit en la página de producto ("producto + carrito"):
     si la prenda elegida es la que se acaba de agregar a la lista, se descuenta antes
     para que no salga repetida en el formulario. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#rsi_buy_now_button');
    if (!btn) return;
    if (btn.closest('cart-items-component, cart-drawer-component, .cart-drawer')) return;
    if (state.bypass) { state.bypass = false; return; }
    var root = roots()[0]; if (!root || !state.lastAdded) return;
    var id = currentId(root);
    if (!id || String(state.lastAdded.id) !== id) return;
    var line = state.cart && state.cart.items.filter(function (i) { return String(i.variant_id) === id; })[0];
    if (!line) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var left = Math.max(0, line.quantity - (parseInt(state.lastAdded.qty, 10) || 1));
    state.lastAdded = null; saveLast();
    json('/cart/change.js', { id: line.key, quantity: left })
      .then(function (c) { state.cart = c; render(); })
      .catch(function () {})
      .then(function () { state.bypass = true; btn.click(); });
  }, true);

  function init() { if (roots().length) refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('pageshow', function (e) { if (e.persisted) init(); });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:update', function (e) { if (!e.detail || e.detail.sourceId !== 'rz-pedido') setTimeout(refresh, 300); });
  setInterval(paintIncluye, 700);
})();
